import { AppBar, Box, Container, Hidden, Toolbar } from '@material-ui/core';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import React from 'react';

import Brand from '~/images/brand-2024.svg';
import HeaderBench from '~/images/header/bench.svg';
import HeaderClock from '~/images/header/clock.svg';
import HeaderTrain from '~/images/header/train.svg';
import HeaderTrees from '~/images/header/trees.svg';

import { styles } from './styles';

const Header: React.FC = () => {
  const isSticky = useScrollTrigger({
    threshold: 100,
    disableHysteresis: true,
  });

  const classes = styles({ isSticky });

  return (
    <AppBar position="fixed" className={classes.header} elevation={0}>
      <Box className={classes.containerRoot}>
        <Toolbar className={classes.toolbar}>
          <Box></Box>
          <Container className={classes.titleRow}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://radparken.info/"
              className={classes.titleLink}
            >
              {isSticky ? (
                <Brand className={classes.brandSticky} />
              ) : (
                <div className={classes.brandWrapper}>
                  <Brand className={classes.brand} />
                </div>
              )}
            </a>
            <Hidden smDown>
              <HeaderTrees className={classes.headerTrees} width="70px" />
              <Box className={classes.headerBenchWithClock}>
                <HeaderBench
                  width="54px"
                  height="30px"
                  className={classes.headerBench}
                />
                <HeaderClock
                  width="20px"
                  height="60px"
                  className={classes.barIcon}
                />
              </Box>
              <HeaderTrain width="265px" className={classes.barIcon} />
            </Hidden>
          </Container>
        </Toolbar>
      </Box>
    </AppBar>
  );
};

export default Header;
